<template>
  <div class="faq">
    <h1 class="faq-title">{{ $t('menu_faq') }}</h1>
    <v-container>
      <v-row>
        <v-col cols="12">
          <!-- 質問 1 -->
          <v-card class="mb-4">
            <v-card-title class="font-weight-bold">{{ $t('faq.question_1') }}</v-card-title>
            <v-card-text>{{ $t('faq.answer_1') }}</v-card-text>
          </v-card>

          <!-- 質問 2 -->
          <v-card class="mb-4">
            <v-card-title class="font-weight-bold">{{ $t('faq.question_2') }}</v-card-title>
            <v-card-text>{{ $t('faq.answer_2') }}</v-card-text>
          </v-card>

          <!-- 質問 3 -->
          <v-card class="mb-4">
            <v-card-title class="font-weight-bold">{{ $t('faq.question_3') }}</v-card-title>
            <v-card-text>{{ $t('faq.answer_3') }}</v-card-text>
          </v-card>

          <!-- 質問 4 -->
          <v-card class="mb-4">
            <v-card-title class="font-weight-bold">{{ $t('faq.question_4') }}</v-card-title>
            <v-card-text>{{ $t('faq.answer_4') }}</v-card-text>
          </v-card>

          <!-- 質問 5 -->
          <v-card class="mb-4">
            <v-card-title class="font-weight-bold">{{ $t('faq.question_5') }}</v-card-title>
            <v-card-text>{{ $t('faq.answer_5') }}</v-card-text>
          </v-card>

          <!-- 質問 6 -->
          <v-card class="mb-4">
            <v-card-title class="font-weight-bold">{{ $t('faq.question_6') }}</v-card-title>
            <v-card-text>{{ $t('faq.answer_6') }}</v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'FAQContent'
}
</script>

<style scoped>
.faq {
  padding: 20px;
}

.faq-title {
  text-align: center;
  margin-bottom: 20px;
}

.v-card {
  border-radius: 8px;
  padding: 16px;
}

.v-card-title {
  font-size: 18px;
  margin-bottom: 8px;
}

.v-card-text {
  font-size: 16px;
  line-height: 1.5;
}
</style>
